function addItemToCart(event) {
  const button = event.target;

  if (!button.classList.contains('js-add-psbo')) {
    return;
  }

  let variantId = button.dataset.psboId;
  const parentVariantId = button.dataset.psboParent;
  const parentLineKey = button.dataset.psboParentKey;
  const parentTitle = button.dataset.psboParentTitle;
  const discountValue = button.dataset.psboValue;
  const discountPercent = button.dataset.psboPercent;
  const quantity = 1;

  // If no variantId, product has multiple variants — show select first
  if(variantId == '') {
    const card = button.closest('.psbo-card') || button.closest('.card');
    const selectWrap = card ? card.querySelector('.psbo-card__select-wrap') : null;

    if (selectWrap && selectWrap.hidden) {
      // First click: reveal the select
      selectWrap.hidden = false;
      button.textContent = 'Bestätigen';
      return;
    }

    // Second click (or legacy select): read selected value
    const selectEl = card ? card.querySelector('.psbo-card__select') : null;
    if (selectEl) {
      variantId = selectEl.value;
    } else {
      variantId = document.querySelector('#product_'+parentVariantId).value;
    }
  }

  document.querySelector('#cart-items').classList.add('pointer-events-none');

  // Shopify's native nested cart lines: parent_line_key attaches this line to the
  // parent that is already in the cart, so the platform keeps them together in the
  // cart, checkout, order and emails, and removes the child with its parent.
  // The legacy _psbo property is kept because the discount/upsell logic reads it.
  // _psbo_title carries the parent product title for order integrations, which
  // can't see the native nesting in the order's line item properties.
  const item = {
    quantity,
    id: variantId,
    properties: {
      '_psbo': parentVariantId,
    }
  };

  if (parentTitle) item.properties._psbo_title = parentTitle;
  if (parentLineKey) item.parent_line_key = parentLineKey;

  const addItem = (payload) => fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items: [payload] })
  }).then(async (response) => ({ ok: response.ok, data: await response.json() }));

  addItem(item)
    .then((result) => {
      // Shopify can't nest an add-on under a bundle product or one of its components
      // ("Bundle products and add-ons can't be mixed") and rejects the whole request.
      // Retry as a plain line rather than losing the add to cart - the _psbo property
      // still groups it under the parent in the cart.
      if (!result.ok && item.parent_line_key) {
        const flat = { ...item };
        delete flat.parent_line_key;
        return addItem(flat);
      }

      return result;
    })
    .then((result) => {
      if (!result.ok) {
        throw new Error(result.data.description || result.data.message || 'cart error');
      }

      if (document.querySelector('.cc-main-cart')) {
        location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        }));
      }
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);

      // Without this the cart stays greyed out and unclickable after a failed add.
      const cartItems = document.querySelector('#cart-items');
      if (cartItems) cartItems.classList.remove('pointer-events-none');
    });
}

document.addEventListener('click', addItemToCart);